import { LwFormSelect } from 'redesign';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { DocumentLanguage } from 'hq/services/documents-service.types';

const languageLabels: Record<DocumentLanguage, string> = {
  // t('document_language.dutch', { ns: 'hq-screen-specific' })
  nl: 'document_language.dutch',
  // t('document_language.english', { ns: 'hq-screen-specific' })
  en: 'document_language.english',
};

type DocumentLanguageSelectProps = {
  availableLanguages: DocumentLanguage[];
};

export const DocumentLanguageSelect = ({ availableLanguages }: DocumentLanguageSelectProps) => {
  const { t } = useTranslation(['hq-screen-specific', 'web-common']);
  const { control } = useFormContext();

  const languageOptions = availableLanguages.map((lang) => ({
    value: lang,
    label: t(languageLabels[lang], { ns: 'hq-screen-specific' }),
  }));

  return (
    <LwFormSelect
      control={control}
      name="language"
      label={t('table_headers.available_language', { ns: 'web-common' })}
      defaultLabel={t('document_form.select_language', { ns: 'hq-screen-specific' })}
      options={languageOptions}
      disabled={availableLanguages.length <= 1}
      rules={{ required: true }}
    />
  );
};
